import ModalProductoSelectComponente from "@/erp/inventario/ingreso-producto/shared/componente/ModalProductoSelectComponente";
import ModalCuotas from "@/erp/sale/asesor/preventa/shared/component/modal_cuotas/ModalCuotas";
import {
  BucketAwtENUM,
  EstadoFactibilidadCorporativaENUM,
  // EntidadFinancieraENUM,
  EstadoPreventaEnum,
  // EstadosSolicitudEnumChoice,
  // fnMostrarTipoTarjeta,
  // generateUUID,
  // gridSizeMdLg10,
  gridSizeMdLg12,
  gridSizeMdLg3,
  // gridSizeMdLg4,
  gridSizeMdLg6,
  // gridSizeMdLg9,
  ModulosEnumChoice,
  ROUTER_PATHS,
  texto,
  // TIPO_CUENTA_BANCARIA_CHOICE,
  // TipoCuentaBancariaEnumChoice,
  useLoaders,
  useTableColumnsInventario,
  useUploadFile,
} from "@/shared";
import {
  useFetchCoberturasSector,
  // useFetchIpv4Groups,
  useFetchMotivosRechazo,
} from "@/shared/actions/erp";
// import { useGetCapacidadCorporativo } from '@/shared/actions/erp/planes/planes_corporativos.actions';
// import { useFetchEmpleados } from '@/shared/actions/erp/empleados';
import {
  useFetchPostFactibilidadCorporativo,
  useFetchPutFactibilidadCorporativo,
} from "@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions";
import { useGetPlanCorporativo } from "@/shared/actions/erp/planes";
import { fetchPutPreventaCorporativo } from "@/shared/actions/erp/preventa_corporativo/preventa_corporativo.action";
import {
  CustomAutocomplete,
  CustomAutocompleteArrString,
  // CustomAutocompleteArrString,
  CustomNumberTextField,
  CustomTextArea,
  CustomTextAreaNoForm,
  CustomTextField,
  // CustomTextAreaNoForm,
  CustomTextFieldNoForm,
  CustomTextFieldNumberComponente,
  DropzoneFiles,
  SampleCheckbox,
  SampleDatePicker,
  // SampleDatePicker,
  SampleTable,
  StepperBoxScene,
  TabTextLabel,
} from "@/shared/components/ui";
import { TiposTextFieldNumberEnum } from "@/shared/components/ui/CustomTextFieldNumberComponente";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import {
  AlertSeverityEnum,
  CategoriaFCorporativaEnum,
  // Cooperativa,
  // EntidadesFinancieras,
  // IPaymentMethod,
  MaterialTransferido,
  MotivoRechazo,
  // PaymentMethodEnum,
  PlanesCorporativos,
  Sector,
  // SubmascaraRedEnum,
  // TIPO_PLAN_CORPORATIVO_CHOICE,
  TipoPlanCorporativo,
} from "@/shared/interfaces";
// import { CapacidadCorporativa } from '@/shared/interfaces/erp/planes_corporativos/planes_corporativos.interface';
import { IPreventaCorporativoForm2 } from "@/shared/interfaces/erp/preventa/preventa_corporativo.interface";
import {
  ModalMotivoForm,
  newModalMotivoFormaSchema,
} from "@/shared/utils/validation-schemas/erp/ventas/preventa/preventa_corporativo.schema";
import { MaterialesKey, useMaterialesUtilizadosStore } from "@/store/erp";
// import { usePaymentMethodsStore } from "@/store/erp/system-settings/payment-methods";
import { usePlanStore } from "@/store/erp/system-settings/plan.store";
import { useUiStore } from "@/store/ui";
import { yupResolver } from "@hookform/resolvers/yup";
import { Info } from "@mui/icons-material";
import {
  Alert,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from "@mui/material";

// import dayjs from "dayjs";
import { CondicionVentaCorporativa } from "@/shared/interfaces/erp/prospecto/prospecto_corporativo.interface";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
// import { useFetchPutSolicitudCanje } from "@/shared/actions/erp/marketing";
// import { useFetchPutSolicitudEvento } from "@/shared/actions/erp/marketing/solicitudEvento.action";
import CustomCoordendasForm from "@/erp/venta-corporativa/preventa_corporativo/shared/form_coordenadas/CustomCoordendasForm";
import {
  IFactibilidadCorporativo,
  IFactibilidadCorporativoParams,
} from "@/shared/interfaces/erp/factibilidad_corporativo";
import { useAuthStore } from "@/store/auth";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import ViewDocumentosCoorporativosPage from "../../page/view_documentos_corporativos/ViewDocumentosCoorporativosPage";
// import CargarDocumentoSoluccionCosteada from "@/erp/venta-corporativa/solucion_costeada/shared/componente/cargar_documento_soluccion_costeada/CargarDocumentoSoluccionCosteada";

import FileUploadSection from "../../components/FileUploadSectionProps/FileUploadSections";
const steps = [
  "Datos Generales",
  // "Características del Enlace",
  // "Detalles de Plan",
  // "Servicios Adicionales",
  // "Material y Equipos",
];

const TIPO_PUERTOS_SERVICIO = ["ELECTRICO", "OPTICO 1G", "OPTICO 10G"];
const MEDIO_ULTIMA_MILLA = ["FIBRA", "CABLEADO", "INALAMBRICO"];

type AddMaterialFactibilidadCorporativoPageProps = {
  title: string;
  dataPreventa: IPreventaCorporativoForm2;
  dataFactibilidadCorporativa?: IFactibilidadCorporativo;
  updateFactibilidad: boolean;
  showSaveButton?: boolean;
  aprobacionPage?: boolean;
  DISABLE_FIELD?: boolean;
};

export default function AddMaterialFactibilidadCorporativoPage({
  title,
  dataPreventa,
  dataFactibilidadCorporativa,
  updateFactibilidad = false,
  showSaveButton = true,
  DISABLE_FIELD = false,
}: AddMaterialFactibilidadCorporativoPageProps) {
  const user = useAuthStore((s) => s.user);
  const navigate = useNavigate();
  const RETURN_URL_FACTIBILIDADCORPORATIVA =
    ROUTER_PATHS.noc.factibilidadCorporativoNav;
  const REQUIERE_INSPECCION =
    dataPreventa?.prospecto_corporativo_data?.requiere_inspeccion ||
    dataFactibilidadCorporativa?.prospecto_corporativo_data
      ?.requiere_inspeccion;

  const [activeStep, setActiveStep] = useState(0);
  const [disableNextStepBtn] = useState(false);
  const [skipped, setSkipped] = useState(new Set<number>());
  const [modalCancelar, setModalCancelar] = useState(false);

  // PRV-002: Estados para Información Adicional de Inspección
  // Se inicializa desde factibilidad si existe, sino desde preventa
  const [areaResponsableInspeccion, setAreaResponsableInspeccion] = useState<
    "FIBRA" | "RADIO" | null
  >(
    dataFactibilidadCorporativa?.area_responsable_inspeccion ||
      dataPreventa?.area_responsable_inspeccion ||
      null,
  );
  const [archivoInspeccionAdicional, setArchivoInspeccionAdicional] =
    useState<File | null>(null);
  const [urlArchivoInspeccionGuardado, setUrlArchivoInspeccionGuardado] =
    useState<string | null>(
      dataFactibilidadCorporativa?.url_archivo_inspeccion_adicional ||
        dataPreventa?.url_archivo_inspeccion_adicional ||
        null,
    );
  //
  const [archivoPropuestaTecnica, setArchivoPropuestaTecnica] =
    useState<File | null>(null);
  const [
    urlArchivoPropuestaTecnicaGuardado,
    setUrlArchivoPropuestaTecnicaGuardado,
  ] = useState<string | null>(
    dataFactibilidadCorporativa?.url_archivo_propuesta_tecnica ||
      dataPreventa?.url_archivo_propuesta_tecnica ||
      null,
  );
  ///* Store y hooks
  const { handleUploadFile } = useUploadFile();
  ///* Store y hooks
  const ingresoProductos = useMaterialesUtilizadosStore(
    (s) => s.ingresoProductos,
  );
  const serviciosAdicionalesDigitales = useMaterialesUtilizadosStore(
    (s) => s.serviciosAdicionalesDigitales,
  );
  const setSelectedItems = useMaterialesUtilizadosStore(
    (s) => s.setSelectedItems,
  );
  const addSelectedItemProducto = useMaterialesUtilizadosStore(
    (s) => s.addSelectedItemProducto,
  );
  const clearSelectedItems = useMaterialesUtilizadosStore(
    (s) => s.clearSelectedItems,
  );
  const copyArray = useMaterialesUtilizadosStore((s) => s.copyArray);
  const planesCorporativosGlobal = usePlanStore((s) => s.plansCorporativos);
  const getPlansCorporativos = usePlanStore((s) => s.getPlansCorporativos);

  // const clearSelectedItems = useMaterialesUtilizadosStore(s => s.clearSelectedItems);
  const { columnsItemFactibilidadCorporativa } = useTableColumnsInventario({
    key: MaterialesKey.ingresoProductos,
  });
  const { columnsItemMaterialesEquipos } = useTableColumnsInventario({
    key: MaterialesKey.ingresoProductos,
  });
  const { columnsItemServiciosDigitalesFactibilidad } =
    useTableColumnsInventario({
      key: MaterialesKey.serviciosAdicionalesDigitales,
    });

  const setAlert = useUiStore((s) => s.setAlert);
  ///* Fetch
  const { mutateAsync: mutateAsyncPostFactibilidadCorporativo } =
    useFetchPostFactibilidadCorporativo({
      enableSuccessAlert: true,
      navigate,
      returnUrl: RETURN_URL_FACTIBILIDADCORPORATIVA,
    });
  const {
    mutate: mutatePutFactibilidadCorporativa,
    mutateAsync: mutateAsyncPutFactibilidadCorporativa,
  } = useFetchPutFactibilidadCorporativo({
    enableSuccessAlert: true,
    navigate,
    returnUrl: RETURN_URL_FACTIBILIDADCORPORATIVA,
  });

  const { mutateAsync: mutateAsyncPutPreventaCorporativa } =
    fetchPutPreventaCorporativo({
      enableSuccessAlert: true,
      navigate,
    });

  const {
    data: motivosRechazoPaging,
    isLoading: isLoadingMotivosRechazo,
    isRefetching: isRefetchingMotivosRechazo,
  } = useFetchMotivosRechazo(
    {
      estado: true,
      modulo: ModulosEnumChoice.FACTIBILIDAD_CORPORATIVO,
      page_size: 100,
    },
    modalCancelar,
  );

  const { mutateAsync: mutateAsyncPutPreventa, isPending } =
    fetchPutPreventaCorporativo({
      navigate,
      returnUrl: ROUTER_PATHS.noc.factibilidadCorporativoNav,
    });

  ///* Form
  const form = useForm<IPreventaCorporativoForm2>({});
  const formPreventaCorporativa = useForm<IPreventaCorporativoForm2>({});
  const {
    formState: { errors },
  } = form;

  const formRechazo = useForm<ModalMotivoForm>({
    resolver: yupResolver(newModalMotivoFormaSchema),
  });

  const { handleSubmit, reset, control } = form;

  const handleNext = () => {
    let newSkipped = skipped;
    // prevent finish step
    if (activeStep === steps.length - 1) return;
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  useEffect(() => {

    setSelectedItems(
      dataPreventa?.servicios_adicionales || [],
      MaterialesKey.serviciosAdicionalesDigitales,
    );
    if (dataFactibilidadCorporativa) {
      reset({
        ...dataPreventa,
        ...dataFactibilidadCorporativa,
        observacion_prefactibilidad:
          dataFactibilidadCorporativa?.observaciones
            ?.observacion_prefactibilidad,
        celular_1:
          dataFactibilidadCorporativa?.prospecto_corporativo_data?.celular,
        celular_2:
          dataFactibilidadCorporativa?.preventa_corporativa_data?.celular_2,
        telefono:
          dataFactibilidadCorporativa?.prospecto_corporativo_data?.telefono,
        ejecutivo_comercial:
          dataFactibilidadCorporativa?.prospecto_corporativo_data?.user_create, //agregamos ejecutivo comercial
      });
      formPreventaCorporativa.reset({
        ...dataFactibilidadCorporativa?.preventa_corporativa_data,
        observacion_prefactibilidad:
          dataFactibilidadCorporativa?.observaciones
            ?.observacion_prefactibilidad,
        ejecutivo_comercial:
          dataFactibilidadCorporativa?.prospecto_corporativo_data?.user_create, //agregamos ejecutivo comercial
      });
      getPlansCorporativos({ codigo: dataFactibilidadCorporativa.plan });
      copyArray(
        dataFactibilidadCorporativa.detalles,
        MaterialesKey.ingresoProductos,
      );
    } else {
      reset({
        ...dataPreventa,
        observacion_prefactibilidad:
          dataPreventa?.observaciones?.observacion_prefactibilidad,
        celular_1: dataPreventa?.prospecto_corporativo_data?.celular,
        telefono: dataPreventa?.prospecto_corporativo_data?.telefono,
        ejecutivo_comercial:
          dataPreventa?.prospecto_corporativo_data?.user_create, //agregamos ejecutivo comercial
      });
      formPreventaCorporativa.reset({
        ...dataPreventa,
        observacion_prefactibilidad:
          dataPreventa?.observaciones?.observacion_prefactibilidad,
        ejecutivo_comercial:
          dataPreventa?.prospecto_corporativo_data?.user_create, //agregamos ejecutivo comercial
      });
    }
    return () => {
      clearSelectedItems(MaterialesKey.ingresoProductos);
    };
  }, [dataPreventa, dataFactibilidadCorporativa]);

  const { data: sectorsByZonePaging } = useFetchCoberturasSector({
    zona: form.getValues().zona!,
    page_size: 1000,
    cobertura: true,
    estado: true,
  });

  ///* STATES ------------
  const [loadPlanesCorporativos, setLoadPlanesCorporativos] = useState(false);
  const [DataPlanSelected, setDataPlanSelected] = useState<
    PlanesCorporativos[]
  >([]);

  const {
    data: dataPlanesCorporativos,
  } = useGetPlanCorporativo(
    {
      page_size: 100,
      tipo_plan: form.watch().tipo_plan!,
    },
    loadPlanesCorporativos,
  );

  useEffect(() => {
    if (form.watch().tipo_plan) {
      setLoadPlanesCorporativos(true);
    }
  }, [form.watch().tipo_plan]);

  // ===========================================================================
  // POSTS USEEFFECT
  // ===========================================================================
  useEffect(() => {
    if (dataPlanesCorporativos?.code == 200) {
      const auxDataPlanesCorporativos =
        dataPlanesCorporativos?.data.data.filter(
          (x) => x.codigo == dataPreventa.plan,
        );

      if (auxDataPlanesCorporativos) {
        setDataPlanSelected(auxDataPlanesCorporativos);
      }
    }
  }, [dataPlanesCorporativos]);

  // ===========================================================================
  // Se manejan las acciones del guardado de cambios para los casos
  // cuando no existe factibilidad y cuando si
  // ===========================================================================
  const onSaveFactibilidadCorporativa = async (option: number) => {
    reset({
      ...form.getValues(),
      observacion_factibilidad: form
        .getValues()
        ?.observacion_factibilidad?.toUpperCase(),
    });

    // PRV-002: Subir archivo de inspección PRIMERO si existe (para tener la URL disponible)
    // Se sube siempre que haya un archivo seleccionado, sin importar la opción
    // 2. Se sube siempre que haya un archivo propuesta tecniaca, sin importar la opcion.
    let urlArchivoInspeccion =
      urlArchivoInspeccionGuardado ||
      dataFactibilidadCorporativa?.url_archivo_inspeccion_adicional ||
      dataPreventa?.url_archivo_inspeccion_adicional ||
      null;
    let urlArchivopropuestaTecnica =
      urlArchivoPropuestaTecnicaGuardado ||
      dataFactibilidadCorporativa?.url_archivo_propuesta_tecnica ||
      dataPreventa.url_archivo_propuesta_tecnica ||
      null;
    if (archivoInspeccionAdicional) {
      try {
        const respUpload = await handleUploadFile(
          archivoInspeccionAdicional,
          BucketAwtENUM.INSPECCION_CORPORATIVO,
        );
        const respUpload_1 = await handleUploadFile(
          archivoPropuestaTecnica,
          BucketAwtENUM.PROPUESTA_TECNICA,
        );
        urlArchivoInspeccion = respUpload.url;
        setUrlArchivoInspeccionGuardado(respUpload.url);
        setArchivoInspeccionAdicional(null);
        toast.success("Archivo de inspección subido correctamente");
        //
        urlArchivopropuestaTecnica = respUpload_1.url;
        setUrlArchivoPropuestaTecnicaGuardado(respUpload_1.url);
        setArchivoPropuestaTecnica(null);
        toast.success("Archivo de propuesta técnica subido correctamente");
      } catch (error) {
        toast.error("Error al subir el archivo de inspección");
        console.error("Error uploading file:", error);
        //
        toast.error("Error al subir el archivo de propuesta técnica");
        console.error("Error uploading file:", error);
      }
    }
    mutateAsyncPutPreventaCorporativa({
      id_preventa_coorporativa: form.getValues().id_preventa_coorporativa,
      celular_1: form.getValues().celular_1,
      celular_2: form.getValues().celular_2,
      estado_preventa:
        option == 0
          ? EstadoPreventaEnum.PREAPROBADA
          : EstadoPreventaEnum.EN_PROCESO,
      equipos_adicionales: form.getValues()?.equipos_adicionales,
      plan_tvmax: form.getValues()?.plan_tvmax,

      direccion_fusion: form.getValues()?.direccion_fusion,
      coordenada_fusion: form.getValues()?.coordenada_fusion,
      costo_seguridad_perimetral: form.getValues().costo_seguridad_perimetral,
      costo_wifi_gestionado: form.getValues().costo_wifi_gestionado,
      costo_cableado_interno: form.getValues().costo_cableado_interno,
      costo_fibra_oscura: form.getValues().costo_fibra_oscura,
      tipo_puerto_disponible: form.getValues().tipo_puerto_disponible,
      medio_ultima_milla: form.getValues().medio_ultima_milla,
      servicios_adicionales: serviciosAdicionalesDigitales,
      preventa_aprobada_factibilidad:
        option == 0 || form.getValues().preventa_aprobada_factibilidad
          ? true
          : false,
      observaciones: {
        ...form.getValues()?.observaciones,
        observacion_prefactibilidad:
          form.getValues()?.observacion_prefactibilidad,
        observacion_enlace_backup:
          form.getValues()?.observaciones?.observacion_enlace_backup ||
          dataPreventa?.observaciones?.observacion_enlace_backup,
      },
      datos_preventa_completados: option != 0 ? true : false,
      // PRV-002: Sincronizar campos de información adicional con la preventa
      area_responsable_inspeccion: areaResponsableInspeccion,
      url_archivo_inspeccion_adicional: urlArchivoInspeccion,
      url_archivo_propuesta_tecnica: urlArchivopropuestaTecnica,
    });

    if (option == 0) {
      navigate && navigate(ROUTER_PATHS.noc.factibilidadCorporativoNav);
      return;
    }

    switch (option) {
      case 1:
        // =========================================================================
        // Si no existe la factibilidad corporativa la crea como EN INSPECCION
        // =========================================================================
        if (dataFactibilidadCorporativa === undefined) {
          const sendForm: IFactibilidadCorporativoParams = {
            // ips: form.getValues().ips,
            detalles: ingresoProductos,
            submascara_red: form.getValues().submascara_red,
            prospecto_corporativo:
              dataPreventa!.prospecto_corporativo_data?.codigo,
            preventa_coorporativa: dataPreventa!.codigo,
            estado_factibilidad:
              EstadoFactibilidadCorporativaENUM.EN_INSPECCION,
            observaciones: {
              observacion_factibilidad:
                form.getValues()?.observacion_factibilidad || "N/A",
              // observacion_prefactibilidad: form.getValues()?.preventa_corporativa_data?.observaciones?.observacion_prefactibilidad || form.getValues()?.observacion_prefactibilidad||"N/A",
            },
            // PRV-002: Agregar campos de información adicional
            area_responsable_inspeccion: areaResponsableInspeccion,
            url_archivo_inspeccion_adicional: urlArchivoInspeccion,
            url_archivo_propuesta_tecnica: urlArchivopropuestaTecnica,
          };
          mutateAsyncPostFactibilidadCorporativo(sendForm);
          return;
        }

        const sendFormInspeccion: IFactibilidadCorporativoParams = {
          id_factibilidad_coorporativa:
            dataFactibilidadCorporativa!.id_factibilidad_coorporativa,
          // ips: form.getValues().ips,
          detalles: ingresoProductos,
          submascara_red: form.getValues().submascara_red,
          prospecto_corporativo:
            dataFactibilidadCorporativa!.prospecto_corporativo,
          preventa_coorporativa:
            dataFactibilidadCorporativa!.preventa_coorporativa,
          estado_factibilidad: EstadoFactibilidadCorporativaENUM.EN_INSPECCION,
          observaciones: {
            ...dataFactibilidadCorporativa.observaciones,
            observacion_factibilidad:
              form.getValues()?.observacion_factibilidad || "N/A",
          },
          // PRV-002: Agregar campos de información adicional
          area_responsable_inspeccion: areaResponsableInspeccion,
          url_archivo_inspeccion_adicional: urlArchivoInspeccion,
          url_archivo_propuesta_tecnica: urlArchivopropuestaTecnica,
        };

        mutatePutFactibilidadCorporativa(sendFormInspeccion);

        break;
      // =======================================================================
      // Se guardan los cambios hechos en la prefactibilidad cuando se presiona
      // el guardar cambios desde el tab de solicitudes
      // Si no existe la prefactibilidad la crea y la guarda
      // =======================================================================
      case 2:
        if (dataFactibilidadCorporativa === undefined) {
          const sendForm: IFactibilidadCorporativoParams = {
            // ips: form.getValues().ips,
            detalles: ingresoProductos,
            submascara_red: form.getValues().submascara_red,
            prospecto_corporativo:
              dataPreventa!.prospecto_corporativo_data?.codigo,
            preventa_coorporativa: dataPreventa!.codigo,
            estado_factibilidad: EstadoFactibilidadCorporativaENUM.PENDIENTE,
            observaciones: {
              observacion_factibilidad:
                form.getValues()?.observacion_factibilidad,
            },
            // PRV-002: Agregar campos de información adicional
            area_responsable_inspeccion: areaResponsableInspeccion,
            url_archivo_inspeccion_adicional: urlArchivoInspeccion,
            url_archivo_propuesta_tecnica: urlArchivopropuestaTecnica,
          };
          mutateAsyncPostFactibilidadCorporativo(sendForm);
          return;
        }
        const sendForm: IFactibilidadCorporativoParams = {
          id_factibilidad_coorporativa:
            dataFactibilidadCorporativa!.id_factibilidad_coorporativa,
          detalles: ingresoProductos,
          submascara_red: form.getValues().submascara_red,
          estado_factibilidad: EstadoFactibilidadCorporativaENUM.PENDIENTE,
          prospecto_corporativo:
            dataFactibilidadCorporativa!.prospecto_corporativo,
          preventa_coorporativa:
            dataFactibilidadCorporativa!.preventa_coorporativa,
          observaciones: {
            ...dataFactibilidadCorporativa.observaciones,
            observacion_factibilidad:
              form.getValues()?.observacion_factibilidad || "N/A",
          },
          // PRV-002: Agregar campos de información adicional
          area_responsable_inspeccion: areaResponsableInspeccion,
          url_archivo_inspeccion_adicional: urlArchivoInspeccion,
          url_archivo_propuesta_tecnica: urlArchivopropuestaTecnica,
        };

        mutatePutFactibilidadCorporativa(sendForm);

        break;

      default:
        break;
    }
  };

  const onSendFactibilidadCorporativa = async () => {
    reset({
      ...form.getValues(),
      observacion_factibilidad: form
        .getValues()
        ?.observacion_factibilidad?.toUpperCase(),
    });

    if (!ingresoProductos || ingresoProductos.length === 0)
      return setAlert(
        true,
        "Agregar items para la factibilidad corporativa",
        AlertSeverityEnum.info,
      );

    // PRV-002: Subir archivo de inspección si existe
    let urlArchivoInspeccion =
      urlArchivoInspeccionGuardado ||
      dataFactibilidadCorporativa?.url_archivo_inspeccion_adicional ||
      dataPreventa?.url_archivo_inspeccion_adicional ||
      null;
    let urlArchivopropuestaTecnica =
      urlArchivoPropuestaTecnicaGuardado ||
      dataFactibilidadCorporativa?.url_archivo_propuesta_tecnica ||
      dataPreventa?.url_archivo_propuesta_tecnica ||
      null;
    if (archivoInspeccionAdicional) {
      try {
        const respUpload = await handleUploadFile(
          archivoInspeccionAdicional,
          BucketAwtENUM.INSPECCION_CORPORATIVO,
        );
        const respUpload_1 = await handleUploadFile(
          archivoPropuestaTecnica,
          BucketAwtENUM.PROPUESTA_TECNICA,
        );
        urlArchivoInspeccion = respUpload.url;
        setUrlArchivoInspeccionGuardado(respUpload.url);
        setArchivoInspeccionAdicional(null);
        toast.success("Archivo de inspección subido correctamente");
        //
        urlArchivopropuestaTecnica = respUpload_1.url;
        setUrlArchivoPropuestaTecnicaGuardado(respUpload_1.url);
        setArchivoPropuestaTecnica(null);
        toast.success("Archivo de propuesta tecnica subido correctamente");
      } catch (error) {
        toast.error("Error al subir el archivo de inspección");
        console.error("Error uploading file:", error);
        //
        toast.error("Error al subir el archivo de propuesta tecnica");
        console.error("Error uploading file:", error);
      }
    }

    /// SERVICIOS ADICIONALES
    const ValoresServiciosAdicionales: MaterialTransferido[] = [];

    if (
      serviciosAdicionalesDigitales &&
      serviciosAdicionalesDigitales.length > 0
    ) {
      serviciosAdicionalesDigitales.forEach((servicio) => {
        ValoresServiciosAdicionales.push({
          nombre: servicio.nombre,
          codigo: servicio.codigo,
          id: servicio.id,
          precioUnitario:
            servicio?.precioUnitario ||
            parseFloat(servicio?.producto_data?.precios?.[0]?.precio || "0"),
          cantidad: servicio.cantidad,
          total:
            (servicio?.precioUnitario ||
              parseFloat(
                servicio?.producto_data?.precios?.[0]?.precio || "0",
              )) * ((servicio.cantidad as number) || 1),
          series: [],
          contiene_serie: false,
          categoria_fcorporativa:
            CategoriaFCorporativaEnum.SERVICIOSADICIONALES,
          producto_data: null,
        });
      });
    }

    if (
      dataPreventa &&
      dataPreventa?.num_ips_publicas_facturadas &&
      parseInt(dataPreventa?.num_ips_publicas_facturadas || "0") > 0
    ) {
      ValoresServiciosAdicionales.push({
        nombre: `IPs Facturadas x${dataPreventa?.num_ips_publicas_facturadas}`,
        codigo: "IPSFACTURADAS",
        id: "IPS FACTURADAS",
        precioUnitario: dataPreventa?.costo_valor_ip_facturado || 20,
        cantidad: parseFloat(dataPreventa?.num_ips_publicas_facturadas!) || 0,
        total:
          parseFloat(dataPreventa?.num_ips_publicas_facturadas || "0") *
            (dataPreventa?.costo_valor_ip_facturado || 0) || 0,
        series: [],
        contiene_serie: false,
        categoria_fcorporativa: CategoriaFCorporativaEnum.SERVICIOSADICIONALES,
        producto_data: null,
      });
    }
    const MaterialesEquiposAdicionalesInstalacion: MaterialTransferido[] = (
      ingresoProductos ?? []
    ).map((item) => {
      const precio =
        item.precioUnitario ??
        parseFloat(item.producto_data?.precios?.[0]?.precio || "0");
      const cantidad = item.cantidad;

      return {
        ...item,
        precioUnitario: precio,
        total: precio * Number(cantidad),
      };
    });
    // =========================================================================
    // se esta usando en invenatio?
    // =========================================================================
    if (
      form.getValues()?.equipos_adicionales &&
      form.getValues()?.equipos_adicionales!.length > 0
    ) {
      form.getValues()?.equipos_adicionales?.map((x) => {
        ValoresServiciosAdicionales.push({
          id: x.id,
          codigo: x.codigo,
          nombre: x.codigo,
          precioUnitario: parseFloat(
            x.producto_data?.precios?.[0]?.precio || "0",
          ),
          cantidad: 1,
          total: parseFloat(x.producto_data?.precios?.[0]?.precio || "0"),
          series: [],
          contiene_serie: false,
          categoria_fcorporativa:
            CategoriaFCorporativaEnum.SERVICIOSADICIONALES,
          producto_data: x.producto_data,
        });
      });
    }
    ///DATA PLAN
    const planChoosed = planesCorporativosGlobal.filter(
      (x) => x.codigo == form.getValues()?.plan,
    );
    //Se añadenValores de Plan
    const ValoresPlan: MaterialTransferido[] = [];
    ValoresPlan.push({
      id: form.getValues().plan ?? "",
      codigo: form.getValues().plan!,
      nombre: planChoosed[0]?.nombre || "Enlace de Prueba",
      precioUnitario: form.getValues()?.valor_plan,
      cantidad: 1,
      total: form.getValues()?.valor_plan,
      series: [],
      contiene_serie: false,
      categoria_fcorporativa: CategoriaFCorporativaEnum.VALORESPLAN,
      producto_data: null,
    });
    ValoresPlan.push({
      id: "",
      codigo: form.getValues()?.plan + "-instalacion",
      nombre: "Valor Instalación",
      precioUnitario: form.getValues()?.valor_instalacion,
      cantidad: 1,
      total: form.getValues()?.valor_instalacion,
      series: [],
      contiene_serie: false,
      categoria_fcorporativa: CategoriaFCorporativaEnum.VALORESPLAN,
      producto_data: null,
    });

    const sendForm: IFactibilidadCorporativoParams = {
      ips: form.getValues().ips,
      detalles: ingresoProductos,
      submascara_red: form.getValues().submascara_red,
      productos_costeados: MaterialesEquiposAdicionalesInstalacion.concat(
        ValoresServiciosAdicionales,
      ).concat(ValoresPlan),
      prospecto_corporativo: dataPreventa.prospecto_corporativo,
      preventa_coorporativa: dataPreventa?.codigo!,
      estado_factibilidad: EstadoFactibilidadCorporativaENUM.PENDIENTE,
      aceptado_factibilidad: true,
      enviado_inventario_factibilidad: true,
      observaciones: {
        ...form.getValues()?.observaciones,
        observacion_factibilidad:
          form.getValues()?.observacion_factibilidad || "N/A",
      },
      // PRV-002: Agregar campos de información adicional
      area_responsable_inspeccion: areaResponsableInspeccion,
      url_archivo_inspeccion_adicional: urlArchivoInspeccion,
      url_archivo_propuesta_tecnica: urlArchivopropuestaTecnica,
    };
    // IMPORTANTE: Actualizar PRIMERO la factibilidad y LUEGO la preventa
    // Esto asegura que cuando el backend verifique factibilidades pendientes,
    // esta factibilidad ya esté marcada como aprobada (aceptado_factibilidad=true)
    if (dataFactibilidadCorporativa) {
      await mutateAsyncPutFactibilidadCorporativa({
        ...sendForm,
        id_factibilidad_coorporativa:
          dataFactibilidadCorporativa?.id_factibilidad_coorporativa,
      });
    } else {
      await mutateAsyncPostFactibilidadCorporativo(sendForm);
    }
    // Ahora actualizar la preventa (el backend verificará si hay backups pendientes)
    await mutateAsyncPutPreventaCorporativa({
      id_preventa_coorporativa: dataPreventa.id_preventa_coorporativa,
      estado_preventa: EstadoPreventaEnum.FINALIZADO,
      equipos_adicionales: form.getValues()?.equipos_adicionales,
      celular_1: form.getValues().celular_1,
      celular_2: form.getValues().celular_2,
      plan_tvmax: form.getValues()?.plan_tvmax,
      servicios_adicionales: serviciosAdicionalesDigitales,
      datos_preventa_completados: true,
      // PRV-002: Sincronizar campos de información adicional con la preventa
      area_responsable_inspeccion: areaResponsableInspeccion,
      url_archivo_inspeccion_adicional: urlArchivoInspeccion,
      url_archivo_propuesta_tecnica: urlArchivopropuestaTecnica,
      medio_ultima_milla: form.getValues().medio_ultima_milla,
      tipo_puerto_disponible: form.getValues().tipo_puerto_disponible,
    });
  };

  useLoaders(isPending);

  return (
    <>
      <StepperBoxScene
        py={1}
        titlePage={title}
        num_referencia={dataPreventa?.numero_referencia}
        additionalNoteText={
          <>
            {dataPreventa?.tipo_plan ? (
              <Typography>
                Cliente <b>{dataPreventa?.tipo_plan}</b>
              </Typography>
            ) : null}
            {dataPreventa?.prospecto_corporativo_data?.condicion_venta ||
            dataFactibilidadCorporativa?.prospecto_corporativo_data
              ?.condicion_venta ? (
              <Typography>
                Condición Venta:{" "}
                <b>
                  {dataPreventa?.prospecto_corporativo_data?.condicion_venta ||
                    dataFactibilidadCorporativa?.prospecto_corporativo_data
                      ?.condicion_venta}
                </b>
              </Typography>
            ) : null}
            {dataPreventa.prospecto_corporativo_data?.requiere_cotizacion ||
            dataPreventa.prospecto_corporativo_data?.requiere_inspeccion ? (
              <Typography variant="body1">
                Requiere:
                {"\n"}
                <b>
                  {dataPreventa.prospecto_corporativo_data?.requiere_inspeccion
                    ? "INSPECCIÓN"
                    : ""}
                  {"\n"}
                  {dataPreventa.prospecto_corporativo_data?.requiere_cotizacion
                    ? "COTIZACIÓN"
                    : ""}
                </b>
              </Typography>
            ) : null}
            {title === "Prefactibilidad Corporativa Aprobada" && (
              <Alert severity="info" icon={<Info />} sx={{ mt: 2, mb: 1 }}>
                <Typography variant="body2">
                  <b>Próximo paso:</b> Para continuar con el proceso, diríjase a
                  la opción{" "}
                  <a
                    href={`${import.meta.env.VITE_API_URL}corporativo/preventa`}
                    style={{
                      color: "#1976d2",
                      fontWeight: "bold",
                      textDecoration: "underline",
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Oportunidad Comercial
                  </a>
                  , revise el registro y verifique la información y guarde los
                  datos para continuar con el proceso de Factibilidad.
                </Typography>
              </Alert>
            )}
          </>
        }
        steps={
          steps
        }
        activeStep={activeStep}
        handleNext={handleNext}
        handleBack={handleBack}
        disableNextStepBtn={disableNextStepBtn}
        enableCustomTopRightButton={updateFactibilidad}
        fragmentCustomBottomButtons={
          <>
            {!dataPreventa?.preventa_aprobada_factibilidad ? (
              <Button
                variant="outlined"
                onClick={() => onSaveFactibilidadCorporativa(0)}
              >
                Aprobar Prefactibilidad
              </Button>
            ) : null}
            {DISABLE_FIELD ? null : !dataPreventa?.preventa_aprobada_factibilidad ? null : (!!!dataPreventa
                ?.prospecto_corporativo_data?.condicion_venta &&
                !!!dataFactibilidadCorporativa?.fecha_inspeccion) ||
              (dataPreventa?.prospecto_corporativo_data?.condicion_venta &&
                !!!dataFactibilidadCorporativa?.fecha_inspeccion) ||
              (dataPreventa?.prospecto_corporativo_data?.requiere_inspeccion &&
                !!!dataFactibilidadCorporativa?.fecha_inspeccion) ? (
              <Button
                variant="outlined"
                onClick={() => onSaveFactibilidadCorporativa(1)}
              >
                Enviar a Inspección
              </Button>
            ) : null}
            {DISABLE_FIELD ? null : dataPreventa?.preventa_aprobada_factibilidad ? (
              <Button
                variant="outlined"
                onClick={() => onSaveFactibilidadCorporativa(2)}
              >
                Guardar como Borrador
              </Button>
            ) : null}
          </>
        }
        // actionCustomTopRightButton={onSaveFactibilidadCorporativa}

        onCancel={() => navigate(ROUTER_PATHS.noc.factibilidadCorporativoNav)}
        customNameOnSave={"Enviar Solicitud a Inventario"}
        onSave={handleSubmit(onSendFactibilidadCorporativa)}
        showSaveButton={
          //no se muestra el botón si ya se ha enviado una vez
          !dataPreventa?.preventa_aprobada_factibilidad
            ? false
            : DISABLE_FIELD
              ? false
              : dataFactibilidadCorporativa?.aceptado_factibilidad ||
                  (!!!dataFactibilidadCorporativa?.fecha_inspeccion &&
                    REQUIERE_INSPECCION) ||
                  (dataPreventa?.estado_preventa ===
                    EstadoPreventaEnum.EN_ESPERA &&
                    REQUIERE_INSPECCION)
                ? false
                : showSaveButton
        }
        onReject={
          !DISABLE_FIELD
            ? () => {
                setModalCancelar(true);
              }
            : undefined
        }
        size={gridSizeMdLg12}
      >
        {/* DATOS GENERALES */}
        {activeStep === 0 && (
          <>
            <Grid>
              <Grid container item {...gridSizeMdLg12} spacing={3}>
                <Grid item {...gridSizeMdLg12} display={"flex"}>
                  <Typography variant="h6">Detalles del Cliente</Typography>
                </Grid>
                <Grid item container spacing={2} {...gridSizeMdLg12}>
                  <CustomTextFieldNoForm
                    disabled={true}
                    label={"Razon Social"}
                    defaultValue={
                      form.getValues()?.prospecto_corporativo_data?.razon_social
                    }
                    value={
                      form.getValues()?.prospecto_corporativo_data?.razon_social
                    }
                    shrink={
                      !!form.getValues()?.prospecto_corporativo_data
                        ?.razon_social
                    }
                    size={gridSizeMdLg6}
                  />
                  <CustomTextFieldNoForm
                    disabled={true}
                    label={"RUC"}
                    defaultValue={
                      form.getValues()?.prospecto_corporativo_data
                        ?.identificacion
                    }
                    value={
                      form.getValues()?.prospecto_corporativo_data
                        ?.identificacion
                    }
                    shrink={
                      !!form.getValues()?.prospecto_corporativo_data
                        ?.identificacion
                    }
                    size={gridSizeMdLg6}
                  />
                  <CustomTextFieldNumberComponente
                    size={gridSizeMdLg6}
                    type={TiposTextFieldNumberEnum.CELULAR}
                    label={texto.celular}
                    error={errors.celular_1}
                    helperText={errors.celular_1?.message}
                    control={control}
                    name="celular_1"
                    defaultValue={
                      form.getValues()?.celular_1 ||
                      form.getValues()?.celular ||
                      ""
                    }
                    disabled={DISABLE_FIELD}
                  />
                </Grid>
                <CustomTextAreaNoForm
                  label="Observación Vendedor"
                  value={
                    dataPreventa?.observaciones?.observacion_vendedor ||
                    dataPreventa?.prospecto_corporativo_data?.observaciones
                      ?.observacion_vendedor ||
                    "N/A"
                  }
                  shrink
                  size={gridSizeMdLg6}
                  required={false}
                  // disabled={true}
                  readonly
                  autoGrow
                  maxRows={14}
                />
                {dataPreventa?.requiere_backup && (
                  <CustomTextArea
                    label="Observación Enlace Backup"
                    name="observacion_enlace_backup"
                    typeOfEntry={"observacion"}
                    autoGrow
                    maxRows={14}
                    control={form.control}
                    defaultValue={
                      dataPreventa?.observaciones?.observacion_enlace_backup ||
                      formPreventaCorporativa?.getValues().observaciones
                        ?.observacion_enlace_backup ||
                      ""
                    }
                    sxTextField={{
                      border: "2px solid #d1d1d1",
                      borderRadius: "10px",
                    }}
                    required={false}
                    disabled={true}
                    error={form.formState.errors.observacion_enlace_backup}
                    helperText={
                      form.formState.errors.observacion_enlace_backup?.message
                    }
                    size={gridSizeMdLg6}
                  />
                )}

                {form.getValues().prospecto_corporativo_data?.condicion_venta ==
                  CondicionVentaCorporativa.EVENTO_GRATUITO ||
                form.getValues().prospecto_corporativo_data?.condicion_venta ==
                  CondicionVentaCorporativa.EVENTO_PAGADO ? (
                  <Grid
                    item
                    container
                    spacing={2}
                    justifyContent={"start"}
                    alignContent={"start"}
                    {...gridSizeMdLg12}
                  >
                    <Grid {...gridSizeMdLg12} mt={2}>
                      <TabTextLabel text="Detalles del Cliente " />
                    </Grid>

                    <SampleDatePicker
                      disabled
                      label="Fecha de Instalación"
                      name="fecha_inicio_evento"
                      control={form.control}
                      defaultValue={null}
                      error={form.formState.errors.fecha_inicio_evento}
                      helperText={
                        form.formState.errors.fecha_inicio_evento?.message
                      }
                      minDate={dayjs()}
                      size={gridSizeMdLg6}
                    />
                    <SampleDatePicker
                      disabled
                      label="Fecha de Instalación"
                      name="fecha_fin_evento"
                      control={form.control}
                      defaultValue={null}
                      error={form.formState.errors.fecha_fin_evento}
                      helperText={
                        form.formState.errors.fecha_fin_evento?.message
                      }
                      minDate={dayjs()}
                      size={gridSizeMdLg6}
                    />
                  </Grid>
                ) : null}

                <Grid
                  item
                  container
                  spacing={2}
                  justifyContent={"start"}
                  alignContent={"start"}
                  {...gridSizeMdLg12}
                >
                  <CustomTextField
                    disabled
                    control={control}
                    type="email"
                    name="prospecto_corporativo_data.email"
                    defaultValue={
                      form.getValues().prospecto_corporativo_data?.email || ""
                    }
                    size={gridSizeMdLg6}
                    label={texto.email}
                    error={errors.email}
                    helperText={errors.email?.message}
                  />
                  <CustomTextField
                    disabled
                    control={control}
                    name="prospecto_corporativo_data.persona_contacto"
                    defaultValue={
                      form.getValues().prospecto_corporativo_data
                        ?.persona_contacto || ""
                    }
                    size={gridSizeMdLg6}
                    label={"Persona de Contacto"}
                    error={errors.persona_contacto}
                    helperText={errors.persona_contacto?.message}
                  />
                  <CustomTextField
                    disabled
                    control={control}
                    name="prospecto_corporativo_data.direccion"
                    defaultValue={
                      form.getValues().prospecto_corporativo_data?.direccion ||
                      ""
                    }
                    size={gridSizeMdLg12}
                    label={texto.direccion}
                    error={errors.direccion}
                    helperText={errors.direccion?.message}
                  />
                  <CustomTextField
                    control={control}
                    name="ejecutivo_comercial"
                    defaultValue={form.getValues().ejecutivo_comercial}
                    size={gridSizeMdLg6}
                    label={"Ejecutivo Comercial"}
                    error={undefined}
                    helperText={undefined}
                    disabled={true}
                  />

                  <Grid item container {...gridSizeMdLg3} spacing={3}>
                    <SampleCheckbox
                      size={gridSizeMdLg6}
                      label="¿Tiene CDNs?"
                      control={form.control}
                      name="tiene_cdns"
                      defaultValue={form.getValues().tiene_cdns || false}
                      onChangeValue={(e) => {
                        form.reset({ ...form.getValues(), tiene_cdns: e });
                      }}
                      disabled
                    />
                  </Grid>
                  {form.watch().tiene_cdns && (
                    <>
                      <CustomTextField
                        control={control}
                        name="cdns_detalle"
                        defaultValue={form.getValues().cdns_detalle}
                        size={gridSizeMdLg3}
                        label={"Detalle de CDNs"}
                        error={undefined}
                        helperText={undefined}
                        disabled
                      />
                    </>
                  )}
                </Grid>

                <Grid
                  item
                  container
                  spacing={2}
                  justifyContent={"start"}
                  alignContent={"start"}
                  {...gridSizeMdLg12}
                >
                </Grid>
              </Grid>

              <Grid container item {...gridSizeMdLg12} spacing={3} pt={3}>
                <Grid item {...gridSizeMdLg12} display={"flex"}>
                  <Typography variant="h6">Detalles de Enlace</Typography>
                </Grid>
                <Grid item container spacing={3} {...gridSizeMdLg6}>
                  <CustomAutocompleteArrString
                    size={gridSizeMdLg12}
                    label={"Medio / Última Milla"}
                    name="medio_ultima_milla"
                    options={MEDIO_ULTIMA_MILLA}
                    defaultValue={form.getValues().medio_ultima_milla}
                    isLoadingData={false}
                    control={form.control}
                    error={errors.medio_ultima_milla}
                    helperText={errors.medio_ultima_milla?.message}
                    required={false}
                  />
                  <CustomAutocompleteArrString
                    size={gridSizeMdLg12}
                    label={"Tipo de Puertos para Recibir el Servicio"}
                    name="tipo_puerto_disponible"
                    options={TIPO_PUERTOS_SERVICIO}
                    defaultValue={form.getValues().tipo_puerto_disponible}
                    isLoadingData={false}
                    control={form.control}
                    error={errors.tipo_puerto_disponible}
                    helperText={errors.tipo_puerto_disponible?.message}
                    required={false}
                  />
                </Grid>

                <Grid
                  item
                  container
                  spacing={2}
                  justifyContent={"start"}
                  alignContent={"start"}
                  {...gridSizeMdLg6}
                >
                  <SampleCheckbox
                    size={gridSizeMdLg6}
                    label="Energía Regulada"
                    control={form.control}
                    name="energia_regulada"
                    defaultValue={form.getValues().energia_regulada || false}
                    disabled={true}
                  />
                  <SampleCheckbox
                    size={gridSizeMdLg6}
                    label="Espacio Para Equipos"
                    control={form.control}
                    name="espacio_equipos"
                    defaultValue={form.getValues().espacio_equipos || false}
                    disabled={true}
                  />
                  <SampleCheckbox
                    size={gridSizeMdLg6}
                    label="Zona Soterrada"
                    control={form.control}
                    name="zona_soterrada"
                    defaultValue={form.getValues().zona_soterrada || false}
                    disabled={true}
                  />
                  <SampleCheckbox
                    size={gridSizeMdLg6}
                    label="Instalación por Ductos"
                    control={form.control}
                    name="instalacion_ductos"
                    defaultValue={form.getValues().instalacion_ductos || false}
                    disabled={true}
                  />
                </Grid>

                <Grid {...gridSizeMdLg12} mt={2}>
                  <TabTextLabel text="Ubicación " />
                </Grid>
                <Grid
                  item
                  container
                  spacing={2}
                  justifyContent={"start"}
                  alignContent={"start"}
                  {...gridSizeMdLg12}
                >
                  <CustomCoordendasForm
                    form={form}
                    label="Coordendas de Fusión"
                    name="coordenada_fusion"
                    defaultValue={form.watch().coordenada_fusion}
                    key={"key_coordenada_fusion"}
                    size={gridSizeMdLg6}
                    onlyValueLocation={true}
                    required={false}
                  />
                  <CustomTextField
                    name="direccion_fusion"
                    defaultValue={form.getValues().direccion_fusion}
                    control={form.control}
                    error={form.formState.errors.direccion_fusion}
                    helperText={form.formState.errors.direccion_fusion?.message}
                    shrink={!!form.getValues().direccion_fusion}
                    size={gridSizeMdLg6}
                    label={"Dirección de Fusión"}
                  />

                  <CustomTextFieldNoForm
                    defaultValue={form.getValues().coordenada_servicio}
                    value={form.getValues().coordenada_servicio}
                    shrink={!!form.getValues().coordenada_servicio}
                    size={gridSizeMdLg6}
                    label={"Coordenadas Servicio"}
                    disabled
                  />

                  <CustomTextFieldNoForm
                    defaultValue={form.getValues().direccion_servicio}
                    value={form.getValues().direccion_servicio}
                    shrink={!!form.getValues().direccion_servicio}
                    size={gridSizeMdLg6}
                    label={"Dirección Servicio"}
                    disabled
                  />
                </Grid>
                {/* 
            // =================================================================
            // Ubicación validada por zona
            // =================================================================
            */}
                <Grid item container spacing={2} {...gridSizeMdLg12}>
                  <CustomTextFieldNoForm
                    value={
                      form.getValues()?.sector_tentativo
                        ? form.getValues()?.ciudad_data?.nombre
                        : sectorsByZonePaging?.data?.filter(
                            (x) => x.codigo == form.getValues().sector,
                          )?.[0]?.ciudad_data?.nombre ||
                          dataPreventa?.ciudad_data?.nombre ||
                          dataFactibilidadCorporativa?.ciudad_data?.nombre ||
                          "N/A"
                    }
                    shrink
                    size={gridSizeMdLg6}
                    label={"Ciudad"}
                    disabled={true}
                  />
                  {form.getValues().sector_tentativo ? (
                    <CustomTextFieldNoForm
                      value={form.getValues().sector_tentativo}
                      shrink
                      size={gridSizeMdLg6}
                      label={"Sector"}
                      disabled={true}
                    />
                  ) : (
                    <CustomAutocomplete<Sector>
                      size={gridSizeMdLg6}
                      label={"Sector"}
                      name="sector"
                      options={sectorsByZonePaging?.data || []}
                      defaultValue={form.getValues().sector}
                      isLoadingData={false}
                      control={form.control}
                      error={undefined}
                      helperText={undefined}
                      valueKey="alias" // name is the fk
                      actualValueKey="codigo"
                      disabled={true}
                    />
                  )}
                </Grid>
              </Grid>

              <Grid item container {...gridSizeMdLg12} spacing={3} pt={3}>
                <Grid item container {...gridSizeMdLg12} spacing={3}>

                  {/* ------------- Forma Pago Servicio */}
                  <Grid item container {...gridSizeMdLg12} spacing={3}>
                  </Grid>
                </Grid>

                <Grid item container {...gridSizeMdLg12} spacing={3}>
                  <Grid item container {...gridSizeMdLg12} spacing={3}>
                    <Grid container item>
                      <Typography variant="h6">
                        Detalles del Servicio
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    container
                    spacing={3}
                    {...gridSizeMdLg12}
                    justifyContent={"start"}
                    alignContent={"start"}
                  >
                    <CustomTextFieldNoForm
                      value={
                        form.getValues()?.plan_personalizado
                          ? form.getValues().data_plan_personalizado
                              ?.nombre_personalizado
                          : DataPlanSelected?.[0]?.nombre || ""
                      }
                      size={gridSizeMdLg6}
                      label={"Nombre de Enlace"}
                      shrink={!!DataPlanSelected?.[0]?.nombre}
                      disabled={true}
                    />
                    <CustomTextFieldNoForm
                      value={
                        form.getValues()?.plan_personalizado
                          ? form.getValues().data_plan_personalizado
                              ?.tipo_plan_personalizado
                          : DataPlanSelected?.[0]?.tipo_plan || ""
                      }
                      size={gridSizeMdLg6}
                      label={"Subtipo de Contrato"}
                      shrink={!!DataPlanSelected?.[0]?.tipo_plan}
                      disabled={true}
                    />
                    <CustomTextFieldNoForm
                      value={
                        form.getValues()?.plan_personalizado
                          ? form.getValues().data_plan_personalizado
                              ?.permanencia_personalizado
                          : DataPlanSelected?.[0]?.permanencia || ""
                      }
                      size={gridSizeMdLg6}
                      label={"Tiempo de Permanencia"}
                      shrink={!!DataPlanSelected?.[0]?.permanencia}
                      disabled={true}
                    />
                    <CustomTextFieldNoForm
                      value={
                        form.getValues()?.plan_personalizado
                          ? form.getValues().data_plan_personalizado
                              ?.capacidad_personalizado || "0"
                          : DataPlanSelected?.[0]?.capacidad || ""
                      }
                      size={gridSizeMdLg6}
                      label={"Enlace (Mbps)"}
                      shrink={true}
                      disabled={true}
                    />
                    <CustomTextFieldNoForm
                      value={
                        form.getValues()?.plan_personalizado
                          ? form.getValues().data_plan_personalizado
                              ?.valor_personalizado || "0"
                          : DataPlanSelected?.[0]?.valor || "0"
                      }
                      size={gridSizeMdLg6}
                      label={"Valor"}
                      shrink={true}
                      disabled={true}
                    />
                    <CustomTextFieldNoForm
                      value={
                        form.getValues()?.plan_personalizado
                          ? form.getValues().data_plan_personalizado
                              ?.costo_instalacion_personalizado || "0"
                          : DataPlanSelected?.[0]?.costo_instalacion || "0"
                      }
                      size={gridSizeMdLg3}
                      label={`Valor Instalación ${!form.getValues()?.plan_personalizado ? "Referencial" : ""}`}
                      shrink={true}
                      disabled={true}
                    />
                    {!form.getValues()?.plan_personalizado ? (
                      <CustomNumberTextField
                        control={control}
                        name="valor_instalacion"
                        defaultValue={form.getValues().valor_instalacion || "0"}
                        size={gridSizeMdLg3}
                        label={"Valor de Instalación"}
                        error={errors.valor_instalacion}
                        helperText={errors.valor_instalacion?.message}
                        disabled
                      />
                    ) : null}
                    <CustomTextFieldNoForm
                      value={form.getValues().bonificacion || "0"}
                      size={gridSizeMdLg6}
                      label={"Bonificación (Mbps)"}
                      disabled={true}
                      shrink={!!form.getValues().bonificacion}
                    />
                    <CustomTextField
                      label={"Velocidad Total"}
                      name="velocidad_total"
                      defaultValue={
                        form.getValues().velocidad_total ||
                        DataPlanSelected?.[0]?.capacidad ||
                        "0"
                      }
                      size={gridSizeMdLg6}
                      shrink={!!form.getValues().velocidad_total}
                      control={control}
                      error={errors.velocidad_total}
                      helperText={errors?.velocidad_total?.message}
                      disabled={true}
                    />
                    <CustomTextField
                      label={"Disponibilidad"}
                      name="disponibilidad"
                      defaultValue={form.getValues().disponibilidad || "0"}
                      size={gridSizeMdLg6}
                      shrink={!!form.getValues().disponibilidad}
                      control={control}
                      error={errors.disponibilidad}
                      helperText={errors?.disponibilidad?.message}
                      disabled={true}
                    />
                    {form.getValues()?.tipo_plan == TipoPlanCorporativo.DEMO ? (
                      <SampleCheckbox
                        label="Requiere Backup"
                        control={form.control}
                        name="requiere_backup"
                        defaultValue={
                          form.getValues()?.requiere_backup || false
                        }
                        onChangeValue={(e) => {
                          form.reset({
                            ...form.getValues(),
                            requiere_backup: e,
                          });
                        }}
                        size={gridSizeMdLg6}
                        disabled
                      />
                    ) : null}
                  </Grid>
                  {form.getValues().prospecto_corporativo_data
                    ?.condicion_venta ==
                    CondicionVentaCorporativa.EVENTO_GRATUITO ||
                  form.getValues().prospecto_corporativo_data
                    ?.condicion_venta ==
                    CondicionVentaCorporativa.EVENTO_PAGADO ||
                  form
                    .getValues()
                    .tipo_plan?.includes(TipoPlanCorporativo.DEMO) ? (
                    <Grid
                      item
                      container
                      spacing={2}
                      justifyContent={"start"}
                      alignContent={"start"}
                      {...gridSizeMdLg12}
                    >
                      <SampleDatePicker
                        disabled
                        label="Fecha de Inicio Enlace"
                        name="fecha_inicio_plan"
                        control={form.control}
                        defaultValue={null}
                        error={form.formState.errors.fecha_inicio_plan}
                        helperText={
                          form.formState.errors.fecha_inicio_plan?.message
                        }
                        minDate={dayjs()}
                        size={gridSizeMdLg6}
                      />
                      <SampleDatePicker
                        disabled
                        label="Fecha de Fin Enlace"
                        name="fecha_fin_plan"
                        control={form.control}
                        defaultValue={null}
                        error={form.formState.errors.fecha_fin_plan}
                        helperText={
                          form.formState.errors.fecha_fin_plan?.message
                        }
                        minDate={dayjs()}
                        size={gridSizeMdLg6}
                      />
                    </Grid>
                  ) : null}

                  <Grid
                    item
                    container
                    spacing={3}
                    {...gridSizeMdLg12}
                    justifyContent={"start"}
                    alignContent={"start"}
                  ></Grid>
                </Grid>
                <Grid
                  item
                  container
                  spacing={3}
                  {...gridSizeMdLg12}
                  justifyContent={"start"}
                  alignContent={"start"}
                ></Grid>
                {formPreventaCorporativa.getValues()?.documentos &&
                (formPreventaCorporativa.getValues()?.documentos?.length || 0) >
                  0 ? (
                  <Grid
                    item
                    spacing={2}
                    p={2}
                    justifyContent={"start"}
                    alignContent={"start"}
                    {...gridSizeMdLg12}
                  >
                    <DropzoneFiles
                      form={formPreventaCorporativa}
                      showButtonNewDocuments={false}
                      titleCargaAnexos="Documentos de Preventa"
                    />
                  </Grid>
                ) : (
                  <Grid
                    item
                    spacing={2}
                    p={2}
                    justifyContent={"start"}
                    alignContent={"start"}
                    {...gridSizeMdLg12}
                  >
                    <Typography variant="h6">
                      No se han cargado documentos
                    </Typography>
                  </Grid>
                )}
              </Grid>

              <Grid item container {...gridSizeMdLg12} spacing={3}>
                <Grid item {...gridSizeMdLg12} display={"flex"} mt={2}>
                  <Typography variant="h6">Servicios Adicionales</Typography>
                </Grid>
                <Grid
                  item
                  container
                  spacing={3}
                  {...gridSizeMdLg12}
                  justifyContent={"start"}
                  alignContent={"start"}
                >
                  <Grid item xs={12}>
                    <SampleTable<any>
                      columns={columnsItemServiciosDigitalesFactibilidad}
                      data={
                        serviciosAdicionalesDigitales ||
                        []
                      }
                    />
                  </Grid>
                </Grid>

                <Grid
                  item
                  container
                  spacing={3}
                  {...gridSizeMdLg12}
                  justifyContent={"start"}
                  alignContent={"start"}
                >
                  <CustomTextField
                    control={form.control}
                    name="num_ips_publicas"
                    defaultValue={form.getValues().num_ips_publicas}
                    size={gridSizeMdLg3}
                    label={"Número de IPs públicas"}
                    error={form.formState.errors.num_ips_publicas}
                    helperText={form.formState.errors.num_ips_publicas?.message}
                    disabled={true}
                  />
                  <CustomNumberTextField
                    control={form.control}
                    name="num_ips_publicas_facturadas"
                    defaultValue={form.getValues().num_ips_publicas_facturadas}
                    size={gridSizeMdLg3}
                    label={"Número de IPs públicas Facturadas"}
                    error={form.formState.errors.num_ips_publicas_facturadas}
                    helperText={
                      form.formState.errors.num_ips_publicas_facturadas?.message
                    }
                    disabled={true}
                  />
                  <CustomNumberTextField
                    control={form.control}
                    name="costo_valor_ip_facturado"
                    defaultValue={"20"}
                    size={gridSizeMdLg3}
                    label={"Valor IPs Facturadas ($)"}
                    error={form.formState.errors.costo_valor_ip_facturado}
                    helperText={
                      form.formState.errors.costo_valor_ip_facturado?.message
                    }
                    disabled={true}
                  />
                  <CustomTextFieldNoForm
                    value={
                      form.watch().num_ips_publicas_facturadas &&
                      form.getValues().costo_valor_ip_facturado
                        ? (
                            (parseFloat(
                              form.getValues().num_ips_publicas_facturadas,
                            ) || 0) *
                            (form.getValues().costo_valor_ip_facturado || 0)
                          ).toString()
                        : "0"
                    }
                    size={gridSizeMdLg3}
                    label={"Valor a Pagar ($)"}
                    disabled={true}
                  />
                  <ModalCuotas />
                </Grid>
              </Grid>

              {/* 
          SE PONE TODO EN UN SOLO TAB
          */}
              <Grid container spacing={3} mt={5}>
                {/* 
              // =================================================================
              // MATERIALES Y EQUIPOS DE INSTALACIÓN
              // =================================================================
              */}
                <Grid {...gridSizeMdLg12} container item gap={1}>
                  <Grid {...gridSizeMdLg6} alignContent={"center"}>
                    <Typography variant="h6">
                      Materiales y Equipos de Instalación
                    </Typography>
                  </Grid>
                </Grid>
                <Grid {...gridSizeMdLg12} container justifyContent={"end"}>
                  {/* En Pre-Factibilidad (!dataFactibilidadCorporativa) no se permite agregar items */}
                  {DISABLE_FIELD || !dataFactibilidadCorporativa ? null : (
                    <ModalProductoSelectComponente
                      onChange={(e) => {
                        const aux: MaterialTransferido = {
                          id: e.id_producto,
                          cantidad: 1,
                          codigo: e.codigo,
                          series: [],
                          contiene_serie: e.contiene_serie,
                          categoria_fcorporativa:
                            CategoriaFCorporativaEnum.MATERIALESEQUIPOS,
                          producto_data: {
                            categoria_producto: e.categoria_producto,
                            codigo: e.codigo,
                            descripcion: e.descripcion,
                            stock_actual: e.stock_actual,
                            subcategoria_producto:
                              e?.subcategoria_producto_data?.nombre || "N/A",
                            precios: e.precios,
                          },
                        };
                        addSelectedItemProducto(
                          aux,
                          MaterialesKey.ingresoProductos,
                        );
                      }}
                    />
                  )}
                </Grid>
                <Grid item xs={12}>
                  <SampleTable<MaterialTransferido>
                    columns={columnsItemMaterialesEquipos}
                    data={(ingresoProductos || []).filter(
                      (x) =>
                        x.categoria_fcorporativa ==
                        CategoriaFCorporativaEnum.MATERIALESEQUIPOS,
                    )}
                  />
                </Grid>

                {/*
              // =================================================================
              // Equipos adicionales del cliente
              // =================================================================
              */}
                <Grid {...gridSizeMdLg12} container item gap={1}>
                  <Grid {...gridSizeMdLg6} alignContent={"center"}>
                    <Typography variant="h6">Equipos Adicionales</Typography>
                  </Grid>
                </Grid>
                <Grid {...gridSizeMdLg12} container justifyContent={"end"}>
                  {DISABLE_FIELD || !dataFactibilidadCorporativa ? null : (
                    <ModalProductoSelectComponente
                      onChange={(e) => {
                        const aux: MaterialTransferido = {
                          id: e.id_producto,
                          cantidad: 1,
                          codigo: e.codigo,
                          series: [],
                          contiene_serie: e.contiene_serie,
                          categoria_fcorporativa:
                            CategoriaFCorporativaEnum.EQUIPOSADICIONALES,
                          producto_data: {
                            categoria_producto: e.categoria_producto,
                            codigo: e.codigo,
                            descripcion: e.descripcion,
                            stock_actual: e.stock_actual,
                            subcategoria_producto:
                              e?.subcategoria_producto_data?.nombre || "N/A",
                            precios: e.precios,
                          },
                        };
                        addSelectedItemProducto(
                          aux,
                          MaterialesKey.ingresoProductos,
                        );
                      }}
                    />
                  )}
                </Grid>
                <Grid item xs={12}>
                  <SampleTable<MaterialTransferido>
                    // rowNumber={true}
                    columns={columnsItemFactibilidadCorporativa}
                    data={(ingresoProductos || []).filter(
                      (x) =>
                        x.categoria_fcorporativa ==
                        CategoriaFCorporativaEnum.EQUIPOSADICIONALES,
                    )}
                  />
                </Grid>

                <Grid container item xs={12} spacing={2}>
                  <CustomTextArea
                    label="Observación Prefactibilidad"
                    name="observacion_prefactibilidad"
                    typeOfEntry={"observacion"}
                    autoGrow
                    maxRows={14}
                    control={form.control}
                    defaultValue={
                      dataPreventa?.observaciones
                        ?.observacion_prefactibilidad ||
                      formPreventaCorporativa?.getValues().observaciones
                        ?.observacion_prefactibilidad ||
                      "N/A"
                    }
                    error={form.formState.errors.observacion_prefactibilidad}
                    helperText={
                      form.formState.errors.observacion_prefactibilidad?.message
                    }
                    sxTextField={{
                      border: "2px solid #d1d1d1",
                      borderRadius: "10px",
                    }}
                    required={false}
                    disabled={DISABLE_FIELD}
                  />

                  <CustomTextArea
                    label="Observación Factibilidad"
                    name="observacion_factibilidad"
                    typeOfEntry={"observacion"}
                    autoGrow
                    maxRows={14}
                    control={form.control}
                    sxTextField={{
                      border: "2px solid #d1d1d1",
                      borderRadius: "10px",
                    }}
                    defaultValue={
                      form.getValues().observaciones
                        ?.observacion_factibilidad ||
                      dataFactibilidadCorporativa?.observaciones
                        ?.observacion_factibilidad ||
                      ""
                    }
                    error={form.formState.errors.observacion_factibilidad}
                    helperText={
                      form.formState.errors.observacion_factibilidad?.message
                    }
                    required={false}
                    disabled={DISABLE_FIELD || !dataFactibilidadCorporativa}
                  />

                  {dataFactibilidadCorporativa ? (
                    <>
                      <CustomTextArea
                        label="Observación Inspección"
                        name="observacion_inspeccion_factibilidad"
                        autoGrow
                        maxRows={14}
                        control={form.control}
                        defaultValue={
                          form.getValues().observaciones
                            ?.observacion_inspeccion_factibilidad ||
                          dataFactibilidadCorporativa?.observaciones
                            ?.observacion_inspeccion_factibilidad ||
                          "***NO SE REGISTRÓ OBSERVACIÓN DE INSPECCIÓN***"
                        }
                        error={
                          form.formState.errors
                            .observacion_inspeccion_factibilidad
                        }
                        helperText={
                          form.formState.errors
                            .observacion_inspeccion_factibilidad?.message
                        }
                        required={false}
                        disabled
                      />
                      {dataFactibilidadCorporativa?.observaciones
                        ?.file_observacion_inspeccion_factibilidad ? (
                        <Grid item>
                          <a
                            target="_blank"
                            href={
                              dataFactibilidadCorporativa?.observaciones
                                ?.file_observacion_inspeccion_factibilidad ||
                              "#"
                            }
                          >
                            <Button variant="outlined">
                              Ver/Descargar Anexo
                            </Button>
                          </a>
                        </Grid>
                      ) : null}
                    </>
                  ) : null}
                </Grid>

                {/* PRV-002: Sección Información Adicional */}
                <Grid container item xs={12} spacing={2} sx={{ mt: 2 }}>
                  <Grid item xs={12}>
                    <Typography
                      variant="h6"
                      sx={{
                        borderBottom: "2px solid #1976d2",
                        paddingBottom: 1,
                        marginBottom: 2,
                      }}
                    >
                      Información Adicional
                    </Typography>
                  </Grid>

                  {/* Área Responsable */}
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{ mb: 1 }}
                    >
                      Área Responsable
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={areaResponsableInspeccion === "FIBRA"}
                              onChange={() => {
                                if (!DISABLE_FIELD) {
                                  setAreaResponsableInspeccion(
                                    areaResponsableInspeccion === "FIBRA"
                                      ? null
                                      : "FIBRA",
                                  );
                                }
                              }}
                              disabled={DISABLE_FIELD}
                            />
                          }
                          label="Fibra"
                        />
                      </Grid>
                      <Grid item>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={areaResponsableInspeccion === "RADIO"}
                              onChange={() => {
                                if (!DISABLE_FIELD) {
                                  setAreaResponsableInspeccion(
                                    areaResponsableInspeccion === "RADIO"
                                      ? null
                                      : "RADIO",
                                  );
                                }
                              }}
                              disabled={DISABLE_FIELD}
                            />
                          }
                          label="Radio"
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* Upload de Archivo */}
                  <Grid item xs={12} container alignItems={"center"}>
                    {/* Documento de Inspeccion */}
                    <Grid container spacing={2}>
                      <Grid item>
                        <FileUploadSection
                          titulo="Documento de Inspección"
                          archivoSeleccionado={archivoInspeccionAdicional}
                          setArchivoSeleccionado={setArchivoInspeccionAdicional}
                          urlArchivoGuardado={
                            urlArchivoInspeccionGuardado ||
                            dataFactibilidadCorporativa?.url_archivo_inspeccion_adicional ||
                            dataPreventa?.url_archivo_inspeccion_adicional
                          }
                          disabledField={DISABLE_FIELD}
                          inputId="archivo-inspeccion"
                        />
                      </Grid>
                    </Grid>

                    {/* Documento  de propuesta Tecnica */}
                    <Grid container spacing={1}>
                      <Grid item>
                        <FileUploadSection
                          titulo="Documento Propuesta Técnica"
                          archivoSeleccionado={archivoPropuestaTecnica}
                          setArchivoSeleccionado={setArchivoPropuestaTecnica}
                          urlArchivoGuardado={
                            urlArchivoPropuestaTecnicaGuardado ||
                            dataFactibilidadCorporativa?.url_archivo_propuesta_tecnica ||
                            dataPreventa?.url_archivo_propuesta_tecnica
                          }
                          disabledField={DISABLE_FIELD}
                          inputId="archivo-propuesta-tecnica"
                        />
                      </Grid>
                    </Grid>

                    {/*  <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
                      Documento de Inspección
                    </Typography>
                    <Grid container>
                      <Grid item >
                        <Typography variant="caption" color="textSecondary" sx={{ mb: 1, display: 'block' }}>
                          Formatos permitidos: PDF, DOC, DOCX, JPEG, JPG, PNG, XLSX, SVG, TXT y otros formatos de imagen
                        </Typography>
                      </Grid>
                    </Grid> */}

                    {/* Mostrar archivo guardado */}
                    {/*  {(urlArchivoInspeccionGuardado || dataFactibilidadCorporativa?.url_archivo_inspeccion_adicional || dataPreventa?.url_archivo_inspeccion_adicional) && !archivoInspeccionAdicional && (
                      <Grid item sx={{ mb: 2 }}>
                        <Typography variant="body2" color="success.main" sx={{ mb: 1 }}>
                          Archivo guardado:
                        </Typography>
                        <a
                          target="_blank"
                          href={urlArchivoInspeccionGuardado || dataFactibilidadCorporativa?.url_archivo_inspeccion_adicional || dataPreventa?.url_archivo_inspeccion_adicional || "#"}
                          rel="noreferrer"
                        >
                          <Button
                            variant="text"
                            size="small"
                            endIcon={< RiDownloadCloud2Fill size={22} />}
                            sx={{
                              backgroundColor: '#f1f3f4',
                              color: '#333',
                              fontWeight: 600,
                              justifyContent: 'space-between',
                              '&:hover': {
                                backgroundColor: '#e0e0e0',
                              },
                            }}
                          >
                            Ver/Descargar Archivo
                          </Button>

                        </a>
                      </Grid>
                    )} */}

                    {/* Mensaje cuando no hay archivo en modo solo lectura */}
                    {/* {DISABLE_FIELD && !urlArchivoInspeccionGuardado && !dataFactibilidadCorporativa?.url_archivo_inspeccion_adicional && !dataPreventa?.url_archivo_inspeccion_adicional && (
                      <Grid item sx={{ mb: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                          No hay documento de inspección cargado
                        </Typography>
                      </Grid>
                    )} */}

                    {/* Input de archivo */}
                    {/*  {!DISABLE_FIELD && (
                      <Grid item mt={1}>
                        <input
                          type="file"
                          accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.xlsx,.xls,.svg,.txt,.gif,.bmp,.webp,.tiff"
                          onChange={(e) => {
                            if (e.target.files && e.target.files[0]) {
                              setArchivoInspeccionAdicional(e.target.files[0]);
                              toast.info(`Archivo seleccionado: ${e.target.files[0].name}`);
                            }
                          }}
                          style={{ display: 'none' }}
                          id="archivo-inspeccion-input"
                        />
                        <label htmlFor="archivo-inspeccion-input">
                          <Button variant="text" component="span" endIcon={<IoMdCloudUpload size={22} />}>
                            {archivoInspeccionAdicional ? 'Cambiar Archivo' : 'Seleccionar Archivo'}
                          </Button>
                        </label>

                        {archivoInspeccionAdicional && (
                          <Typography variant="body2" sx={{ mt: 1, color: 'primary.main' }}>
                            Archivo seleccionado: {archivoInspeccionAdicional.name}
                          </Typography>
                        )}

                      </Grid>
                    )} */}
                    {/* aqui se van los documentos  */}
                    {dataFactibilidadCorporativa?.estado_factibilidad &&
                      user?.area! === "COM-01" && (
                        <Grid container item xs={12}>
                          <ViewDocumentosCoorporativosPage
                            documentosContractuales={
                              dataFactibilidadCorporativa?.documentos
                                ?.documentos_contractuales
                            }
                            documentosHabilitantes={
                              dataFactibilidadCorporativa?.documentos
                                ?.documentos_habilitantes
                            }
                          />
                        </Grid>
                      )}
                  </Grid>
                </Grid>
                {/* FIN PRV-002 */}
              </Grid>
            </Grid>
          </>
        )}
        {/* CARACTERÍSTICAS DEL ENLACE */}
        {/* {activeStep === 1 && (
          <></>
          // <Grid container spacing={3}>
          //   <TabCaracteristicasEnlaceCorporativo
          //     form={form}
          //     dataCapacidadCorporativo={dataCapacidadCorporativo?.data?.data!}
          //     isLoadingCapacidadCorporativo={isLoadingCapacidadCorporativo}
          //     // dataCapacidadCorporativo={[]}
          //     // isLoadingCapacidadCorporativo={false}
          //     disabledAll={true}
          //   />
          // </Grid>
        )} */}

        {/* Detalles de Plan */}
        {/* {activeStep === 2 && (
          <>
            
          </>
        )} */}
        {/* Servicios Adicionales */}
        {/* {activeStep === 3 && (
          <></>
        )} */}
        {/* Material y Equipos */}
        {/* 
        Se ubica en una sola pantalla según lo solicitado
        */}

        {activeStep === 1 && (
          <></>
          // <Grid container spacing={3}>
          //   {
          //     dataFactibilidadCorporativa
          //     && dataFactibilidadCorporativa!.observaciones?.observacion_inspeccion_factibilidad?
          //     <>
          //       <CustomTextArea
          //         label="Observación Inspección"
          //         name="observacion_inspeccion_factibilidad"
          //         maxRows={3}
          //         control={form.control}
          //         defaultValue={
          //           form.getValues().observaciones?.observacion_inspeccion_factibilidad ?? ""
          //         }
          //         error={form.formState.errors.observacion_inspeccion_factibilidad}
          //         helperText={
          //           form.formState.errors.observacion_inspeccion_factibilidad
          //             ?.message
          //         }
          //         required={false}
          //         disabled
          //       />
          //       {
          //         dataFactibilidadCorporativa?.observaciones.file_observacion_inspeccion_factibilidad?
          //         <Grid item>
          //           <a target="_blank" href={dataFactibilidadCorporativa?.observaciones?.file_observacion_inspeccion_factibilidad||"#"}>
          //             <Button variant="outlined">Ver/Descargar Anexo</Button>
          //           </a>
          //         </Grid>
          //         :null
          //       }
          //     </>
          //     :null
          //   }

          //   <CustomTextArea
          //     label="Observación Factibilidad"
          //     name="observacion_factibilidad"
          //     typeOfEntry={'observacion'}
          //     maxRows={3}
          //     control={form.control}
          //     defaultValue={
          //       form.getValues().observaciones?.observacion_factibilidad ?? ""
          //     }
          //     error={form.formState.errors.observacion_factibilidad}
          //     helperText={
          //       form.formState.errors.observacion_factibilidad
          //         ?.message
          //     }
          //     required={false}
          //     disabled={DISABLE_FIELD}
          //   />

          //   {/*
          //   // =================================================================
          //   // MATERIALES Y EQUIPOS DE INSTALACIÓN
          //   // =================================================================
          //    */}
          //   <Grid {...gridSizeMdLg12} container item gap={1}>
          //     <Grid {...gridSizeMdLg6} alignContent={"center"}>
          //       <Typography variant="h6">Materiales y Equipos de Instalación</Typography>
          //     </Grid>
          //   </Grid>
          //   <Grid {...gridSizeMdLg12} container justifyContent={"end"}>
          //     {
          //       DISABLE_FIELD?null:
          //       <ModalProductoSelectComponente
          //         onChange={(e) => {
          //           const aux: MaterialTransferido = {
          //             id: e.id_producto,
          //             cantidad: 1,
          //             codigo: e.codigo,
          //             series: [],
          //             contiene_serie: false,
          //             categoria_fcorporativa: CategoriaFCorporativaEnum.MATERIALESEQUIPOS,
          //             producto_data: {
          //               categoria_producto: e.categoria_producto,
          //               codigo: e.codigo,
          //               descripcion: e.descripcion,
          //               stock_actual: e.stock_actual,
          //               subcategoria_producto: e?.subcategoria_producto_data?.nombre || "N/A",
          //               precios: e.precios,
          //             },
          //           };
          //           addSelectedItemProducto(aux, MaterialesKey.ingresoProductos);
          //         }}
          //       />
          //     }
          //   </Grid>
          //   <Grid item xs={12}>
          //     <SampleTable<MaterialTransferido>
          //       // rowNumber={true}
          //       columns={columnsItemFactibilidadCorporativa}
          //       data={
          //         ingresoProductos.filter(x=>x.categoria_fcorporativa==CategoriaFCorporativaEnum.MATERIALESEQUIPOS)
          //         ||[]
          //       }
          //     />
          //   </Grid>

          //   {/*
          //   // =================================================================
          //   // Equipos adicionales del cliente
          //   // =================================================================
          //    */}
          //    <Grid {...gridSizeMdLg12} container item gap={1}>
          //       <Grid {...gridSizeMdLg6} alignContent={"center"}>
          //         <Typography variant="h6">Equipos Adicionales</Typography>
          //       </Grid>
          //     </Grid>
          //     <Grid {...gridSizeMdLg12} container justifyContent={"end"}>
          //       {
          //         DISABLE_FIELD?null:
          //         <ModalProductoSelectComponente
          //           onChange={(e) => {
          //             const aux: MaterialTransferido = {
          //               id: e.id_producto,
          //               cantidad: 1,
          //               codigo: e.codigo,
          //               series: [],
          //               contiene_serie: false,
          //               categoria_fcorporativa: CategoriaFCorporativaEnum.EQUIPOSADICIONALES,
          //               producto_data: {
          //                 categoria_producto: e.categoria_producto,
          //                 codigo: e.codigo,
          //                 descripcion: e.descripcion,
          //                 stock_actual: e.stock_actual,
          //                 subcategoria_producto: e?.subcategoria_producto_data?.nombre || "N/A",
          //                 precios: e.precios,
          //               },
          //             };
          //             addSelectedItemProducto(aux, MaterialesKey.ingresoProductos);
          //           }}
          //         />
          //       }
          //     </Grid>
          //     <Grid item xs={12}>
          //       <SampleTable<MaterialTransferido>
          //         // rowNumber={true}
          //         columns={columnsItemFactibilidadCorporativa}
          //         data={
          //           ingresoProductos.filter(x=>x.categoria_fcorporativa==CategoriaFCorporativaEnum.EQUIPOSADICIONALES)
          //           || []
          //         }
          //       />
          //     </Grid>

          // </Grid>
        )}
      </StepperBoxScene>

      {/*Modal para cancelar*/}

      {modalCancelar && (
        <ScrollableDialogProps
          open={modalCancelar}
          title="¡Confirmar!"
          confirmVariantBtn="contained"
          dialogContentText={`Estás por rechazar una factibilidad corporativa. ¿Estás seguro este cambio es irreversible?`}
          contentNode={
            <Grid container spacing={3}>
              <CustomAutocomplete<MotivoRechazo>
                label="Motivo de rechazo"
                name="motivo_rechazo"
                // options
                options={motivosRechazoPaging?.data?.data || []}
                valueKey="nombre"
                actualValueKey="nombre"
                defaultValue={formRechazo.getValues().motivo_rechazo || ""}
                isLoadingData={
                  isLoadingMotivosRechazo || isRefetchingMotivosRechazo
                }
                // validation
                control={formRechazo.control}
                error={formRechazo?.formState?.errors.motivo_rechazo}
                helperText={
                  !!formRechazo?.formState?.errors.motivo_rechazo?.message &&
                  "El motivo de rechazo es requerido"
                }
                disableClearable
              />

              <CustomTextArea
                label="Observación"
                name="observacion_motivo_rechazo"
                maxRows={3}
                control={formRechazo.control}
                defaultValue={
                  formRechazo.getValues().observacion_motivo_rechazo ?? ""
                }
                error={formRechazo.formState.errors.observacion_motivo_rechazo}
                helperText={
                  formRechazo.formState.errors.observacion_motivo_rechazo
                    ?.message
                }
                required={false}
              />
            </Grid>
          }
          onConfirm={formRechazo.handleSubmit(async (_form) => {
            if (dataFactibilidadCorporativa === undefined) {
              const dataPrev = dataPreventa.observacion_rechazo || [];
              dataPrev.push({
                motivo: formRechazo.getValues().motivo_rechazo,
                observacion: formRechazo.getValues().observacion_motivo_rechazo,
                fecha: new Date().toISOString(),
              });
              const resp = await mutateAsyncPutPreventa({
                id_preventa_coorporativa:
                  dataPreventa!.id_preventa_coorporativa,
                estado_preventa: EstadoPreventaEnum.PRE_RECHAZADO,
                observacion_rechazo: dataPrev,
              });
              resp.code == 200 && setModalCancelar(false);
              return;
            } else if (dataFactibilidadCorporativa) {
              const dataPrev =
                dataFactibilidadCorporativa.observacion_rechazo || [];
              dataPrev.push({
                observacion: formRechazo.getValues().observacion_motivo_rechazo,
                motivo: formRechazo.getValues().motivo_rechazo,
                fecha: new Date().toISOString(),
              });
              await mutatePutFactibilidadCorporativa({
                id_factibilidad_coorporativa:
                  dataFactibilidadCorporativa!.id_factibilidad_coorporativa,
                estado_factibilidad: EstadoPreventaEnum.PRE_RECHAZADO,
                observacion_rechazo: dataPrev,
                observaciones: {
                  ...dataFactibilidadCorporativa?.observaciones,
                  observacion_factibilidad:
                    form.getValues()?.observacion_factibilidad,
                },
              });
              setModalCancelar(false);
              return;
            } else {
              return toast.error(
                "Error al rechazar este registro corporativo.",
              );
            }
          })}
          onClose={() => {
            setModalCancelar(false);
          }}
        />
      )}
    </>
  );
}
